<template>
  <div>
    <div class="pd-10px has-text-left mgt-5px columns mgb-0 is-vcentered pdr-30px">
      <div class="column is-1">
        <div class="legende-square mgl-20px mgt-10px has-text-centered is-1"
              :class="getColorSquare(affectation)">
          <b-icon size="is-small" icon="clock-outline" type="is-white" class="child-center"
                  v-if="affectation.etatObtenu === EN_ATTENTE_RELANCE_OPTION"/>
          <b-icon icon="close" type="is-danger" class="child-center"
                  v-else-if="etatDesistement.includes(affectation.etatObtenu)"/>
        </div>
      </div>
      <div class="column is-9 is-paddingless mgl-20px">
        <div class="has-text-weight-bold is-marginless has-text-link">
          <b-icon v-if="affectation.nePasReafficher"
            custom-class="height-100" class="mgr-2px"
            type="is-link" icon="minus-circle" size="is-small">
          </b-icon>
          {{ affectation.libelle }}
        </div>
        <div class="columns">
          <span class="has-text-default is-size-7 column is-2">
            {{ affectation.nbFaces }} {{ (affectation.nbFaces === 1 || affectation.nbFaces === 0)
            ? $t('optionBlocage.informationOptionBlocage.face')
            : $t('optionBlocage.informationOptionBlocage.faces') }}
          </span>
          <span class="has-text-default column is-4" v-if="affectation.montantFace">
            {{$t('optionBlocage.informationOptionBlocage.montantFace')}}
            {{ affectation.montantFace  | formatDevise}}
            <b-tooltip v-if="objectif"
              type="is-primary"
              position="is-right"
              :label="objectifAtteint(affectation) ?
                $t('detail.commande.lignesCommande.objectifAtteint',
                  { objectif: objectif })
                : $t('detail.commande.lignesCommande.objectifNonAtteint',
                { objectif: objectif })">
              <b-icon
                :type="objectifAtteint(affectation) ? 'is-success' : 'is-danger'"
                size="is-small"
                icon="checkbox-blank-circle">
              </b-icon>
            </b-tooltip>
          </span>
          <span v-else class=" column is-4"></span>
          <span class="has-text-default column is-3" v-if="affectation.montantLocation">
            {{$t('optionBlocage.informationOptionBlocage.montantLocation')}}
            {{ affectation.montantLocation | formatDevise}}
          </span>
          <span v-else class="column is-3"></span>
          <div class="column is-3 is-paddingless has-text-centered">
            <router-link-blank
              :class="{'mgt-10px' : affectation.societeId === societeActiveId
              || getRouteName(affectation) === 'c.bodac.commandes-venteInterne'}"
              :to="{ name: getRouteName(affectation),
                params: {id: getIdRouterLink(affectation)}}"
              :message="getCode(affectation)"/>
            <div v-if="affectation.societeId !== societeActiveId"
                  class="has-text-weight-bold">
            {{ getLibelleSociete(affectation.societeId) }}
            </div>
          </div>
        </div>
      </div>
      <div class='column is-2 has-text-centered'>
        <b-tooltip
            :label="$t(`optionBlocage.informationOptionBlocage.${
              this.showDetail ? 'cacher' : 'voir'
            }`)">
          <qd-button
              @click="buttonHandler"
              :icon-right="this.showDetail ? 'eye-off' : 'eye'">
          </qd-button>
        </b-tooltip>
      </div>
    </div>
    <hr class="mgl-20px mgr-20px" v-if="isLast">
    <div class="px-4" v-show="showDetail">
      <qd-notification
        class="pd-0 mgb-20px has-background-white"
        :class="{ 'min-height-100': isLoading }"
        ref="element"
        :closable="false">
        <option-blocage-lignes-details-faces
          v-if="!isLoading"
          :lignes="facesAffectee || []">
      </option-blocage-lignes-details-faces>
      </qd-notification>
    </div>
  </div>
</template>

<script>
import { get as getCommande } from '@/api/commande/index';
import { get as getDevis } from '@/api/devis';
import { getAllWithIdle as getAllFaces } from '@/api/produit/produitFace';
import moment from 'moment';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import {
  TYPE_DEVIS, TYPE_COMMANDE, ETAT_FACTURE, ETAT_FACTURE_PARTIELLEMENT,
} from '@/configuration/devisConf';
import {
  BLOQUE,
  EN_ATTENTE_RELANCE_OPTION,
  OPTION,
  RELANCE_OPTION,
  SANS_SUITE,
  INDISPONIBLE,
  ANNULATION,
} from '@/configuration/optionBlocage/optionBlocage';
import optionBlocageLignesDetailsFaces from '@/components/optionBlocage/optionBlocageLignesDetailsFaces';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'ReseauOptionBlocageLignes',
  props: {
    affectation: {
      type: Object,
      required: true,
    },
    produitReseau: {
      type: Object,
      default: null,
    },
    idReseau: {
      type: String,
      required: true,
    },
    anneeSemaine: {
      type: String,
      required: true,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    objectif: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      EN_ATTENTE_RELANCE_OPTION: EN_ATTENTE_RELANCE_OPTION,
      facesAffectee: null,
      isLoading: false,
      showDetail: false,
      etatDesistement: [INDISPONIBLE, SANS_SUITE, ANNULATION],
    };
  },
  components: {
    optionBlocageLignesDetailsFaces,
    routerLinkBlank,
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
    }),
    loading() {
      return this.isLoading || (this.produitReseau === null);
    },
    faceReseau() {
      return this.produitReseau.affectationsReseauFace.filter(face => {
        return moment(this.anneeSemaine, 'YYYYWW').isAfter(moment(face.dateDebut))
        && face.dateFin ? moment(this.anneeSemaine, 'YYYYWW').isBefore(moment(face.dateFin)) : true;
      });
    },
  },
  methods: {
    getLibelleSociete(societeId) {
      const societeFind = this.societesInformations.find((s) => {
        return s.id === societeId;
      });
      return societeFind ? societeFind.libelle : null;
    },
    objectifAtteint(affectation) {
      return affectation.montantFace >= this.objectif;
    },
    getRouteName(affectation) {
      if (affectation.typeReference === TYPE_DEVIS) {
        return 'c.bodac.devis';
      }
      if (affectation.typeReference === TYPE_COMMANDE) {
        if (affectation.commandeInterne
          && affectation.commandeInterne.societeId === this.societeActiveId) {
          return 'c.bodac.commandes-venteInterne';
        } return 'c.bodac.commandes';
      }
      return 'c.bodac.factures';
    },
    getColorSquare(affectation) {
      if (affectation.typeReference === TYPE_DEVIS && affectation.etatObtenu === BLOQUE) {
        return { 'legende-square-bloqueDevis': true };
      }
      if (affectation.typeReference === TYPE_DEVIS
        && (affectation.etatObtenu === EN_ATTENTE_RELANCE_OPTION
          || affectation.etatObtenu === RELANCE_OPTION)) {
        return { 'legende-square-enAttentRelanceOption': true };
      }
      if (affectation.typeReference === TYPE_DEVIS && affectation.etatObtenu === OPTION) {
        return { 'legende-square-option': true };
      }
      if ((affectation.etatReference === ETAT_FACTURE
        || affectation.etatReference === ETAT_FACTURE_PARTIELLEMENT)
        && affectation.etatObtenu === BLOQUE) {
        return { 'legende-square-facture': true };
      }
      if (this.etatDesistement.includes(affectation.etatObtenu)) {
        return { 'legende-square-libre': true };
      }
      return { 'legende-square-bloqueCommande': true };
    },
    getIdRouterLink(affectation) {
      if (this.getRouteName(affectation) === 'c.bodac.commandes-venteInterne') {
        return affectation.commandeInterne.id;
      } return affectation.referenceId;
    },
    getCode(affectation) {
      if (this.getRouteName(affectation) === 'c.bodac.commandes-venteInterne') {
        return affectation.commandeInterne.code;
      } return affectation.codeReference;
    },
    getAffectationReference() {
      if (this.affectation.typeReference === TYPE_COMMANDE) {
        return getCommande(this.affectation.referenceId);
      }
      if (this.affectation.typeReference === TYPE_DEVIS) {
        return getDevis(this.affectation.referenceId);
      }
      return null;
    },
    async tagFacesDansReseau() {
      const taggedFaceAffectee = this.facesAffectee.map(ligne => {
        const face = this.faceReseau.find(f => f.produitId === ligne.produitId);
        if (!face) return ligne;
        face.presence = true;
        return face;
      });
      let facesManquantes = taggedFaceAffectee.filter(f => !f.presence);
      if (facesManquantes.length > 0) {
        facesManquantes = (await getAllFaces({
          query: {
            societeId: this.societeActiveId,
            produitsId: facesManquantes.map(f => f.produitId),
          },
        })).data.result.items;
        taggedFaceAffectee.forEach(face => {
          if (!face.presence) {
            face.produit = facesManquantes.find(f => f.id === face.produitId);
          }
          return face;
        });
      }
      this.facesAffectee = taggedFaceAffectee;
    },
    async buttonHandler() {
      this.showDetail = !this.showDetail;
      if (this.showDetail && this.facesAffectee === null) {
        await this.loadInformations();
      }
    },
    async loadInformations() {
      this.isLoading = true;
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.element.$el,
      });
      try {
        const affectationReference = (await this.getAffectationReference())?.data?.result || [];
        this.facesAffectee = affectationReference?.lignesCommande?.filter(
          ligne => ligne.referenceRegroupement === this.affectation.referenceRegroupement,
        )[0]?.ligneReseau?.lignesCmdSelProduits || [];
        await this.tagFacesDansReseau();
        this.isLoading = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
};
</script>

<style>

</style>
